import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import en from './locales/en.json';
import pl from './locales/pl.json';
import ru from './locales/ru.json';

const supportedLanguages = ['pl', 'en', 'ru'];

let i18nextOptions = {
	order: ['querystring', 'navigator'],
	//   lookupQuerystring: 'lng'
};
const getLanguage = () => {
	const ls = localStorage.getItem('i18nextLng');
	// check if there is a value containing the language key in localStorage.
	if (ls !== null) {
		// Is the language value one of the languages that will be included in our application?
		if (Object.values(supportedLanguages).find((f) => f === ls) !== undefined) return ls;
		else {
			// If it is a language that is not included in the application, use the English language by default
			localStorage.setItem('i18nextLng', 'en');
			return 'en';
		}
	} else {
		// If the user's language is not saved in localstorage
		// Get browser language
		let parsed = navigator.language;
		if (parsed.includes('-')) {
			parsed = parsed.split('-')[0];
		}
		localStorage.setItem('i18nextLng', parsed);
		return parsed;
	}
};

i18n.use(initReactI18next).init({
	lng: getLanguage(),
	// we init with resources
	resources: {
		en: {
			translations: en,
		},
		pl: {
			translations: pl,
		},

		ru: {
			translations: ru,
		},
	},
	fallbackLng: 'en',

	// have a common namespace used around the full app
	defaultNS: 'translations',

	keySeparator: '.',

	interpolation: {
		escapeValue: false, // not needed for react!!
		formatSeparator: ',',
	},

	react: {
		wait: true,
	},
	detection: i18nextOptions,
});

export default i18n;
